<template>
	<div class="flow-application-card" :tabindex="tabindex" @click="handleClick($event)">
		<div class="flow-application-card-content">
			<div class="display-flex j-c-space-bet align-items-start">
				<h4 class="fc-dark text-ellipsis">
					{{ name }}
				</h4>
				<Icon
					name="info-2"
					type="filled"
					state="light"
					size="small"
					:effects="false"
					@click="handleInfoClick($event)"
				/>
			</div>
			<p class="paragraph-2 fc-light margin-bt-16">
				{{ status }}
			</p>
			<div class="display-flex align-items-center">
				<Icon
					:name="iconNames.commit"
					state="white"
					size="x-small"
					:effects="false"
					type="filled"
					class="margin-rt-4"
				/>
				<p class="paragraph-2 fc-light text-ellipsis">
					{{ commit }}
				</p>
			</div>
			<div class="display-flex align-items-center">
				<Icon
					:name="iconNames.branch"
					state="white"
					size="x-small"
					:effects="false"
					type="filled"
					class="margin-rt-4"
				/>
				<p class="paragraph-2 fc-light text-ellipsis">
					{{ branch }}
				</p>
			</div>
		</div>
		<div class="flow-application-card-footer">
			<slot name="footer" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";

export default defineComponent({
	name: "ApplicationCard",
	components: {
		Icon
	},
	props: {
		/**
		 * tabindex number
		 *  */
		tabindex: {
			type: Number,
			default: -1
		},
		/**
		 * Application name
		 */ name: {
			type: String,
			default: null
		},
		/**
		 * Application status e.g. Last build on 10 Dec 03:56
		 */
		status: {
			type: String,
			default: null
		},
		/**
		 * Commit id
		 */
		commit: {
			type: String,
			default: null
		},
		/**
		 * Source code branch name
		 */
		branch: {
			type: String,
			default: null
		},
		/**
		 * { commit: 'git-commit',branch:"git-branch",cost:"doller",server:"aws" }
		 */
		iconNames: {
			type: Object,
			default() {
				return { commit: "git-commit", branch: "git-branch", cost: "doller", server: "aws" };
			}
		}
	},
	methods: {
		handleClick(e) {
			/**
			 * Click event
			 *
			 * @event click
			 */
			this.$emit("click", e);
		},
		handleInfoClick(e) {
			/**
			 * iclick event emitted when I icon clicked
			 *
			 * @event iclick
			 */
			this.$emit("iclick", e);
		}
	}
});
</script>
<style lang="scss">
div.flow-application-card {
	display: flex;
	flex-direction: column;
	border-radius: 8px;
	background-color: var(--slideout-element-light);
	min-height: 150px;

	> div.flow-application-card-content {
		padding: 12px;
		flex: 1 1 auto;
		display: flex;
		// align-items: flex-start;
		flex-direction: column;
	}
	> div.flow-application-card-footer {
		padding: 12px;
		border-top: 1px solid var(--slideout-border);
		max-height: 40px;
		flex: 0 0 auto;
		margin-top: auto;

		display: flex;
		justify-content: center;
		align-items: center;
	}

	&:active {
		filter: contrast(90%);
	}

	&:hover:not(:active) {
		filter: contrast(95%);
	}

	&:focus {
		box-shadow: inset 0 0 0 2px var(--dashboard-primary);
		outline: none;
	}
}
</style>
